import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCashFundGuest = loadable(() => import(/* webpackChunkName: "content/cashfunds/guest" */ './CashFundGuest'));
